export default __webpack_public_path__ + "static/media/starFill.898fe92f.svg";